import { NOTE_TYPE_LABELS, NOTE_TYPES } from '@/modules/notes/constants';
import { NoteTypeFilter } from '@/modules/notes/hooks/useNotesFilters';
import { Modal } from '@/components/common';
import { ModalTitle } from '@/components/common/Modal/common';
import {
  Button,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Checkbox,
} from '@mui/material';

type NotesFiltersModalProps = {
  isOpen: boolean;
  type: NoteTypeFilter;
  showDeleted: boolean;
  // eslint-disable-next-line no-unused-vars
  onTypeChange: (type: NoteTypeFilter) => void;
  // eslint-disable-next-line no-unused-vars
  onShowDeletedChange: (showDeleted: boolean) => void;
  onClose: () => void;
  onApply: () => void;
};

export function NotesFiltersModal({
  isOpen,
  type,
  showDeleted,
  onTypeChange,
  onShowDeletedChange,
  onClose,
  onApply,
}: NotesFiltersModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <ModalTitle title="Filtros" onClose={onClose} />
      <DialogContent sx={{ p: 2 }}>
        <Stack spacing={2} pt={1}>
          <FormControl fullWidth>
            <InputLabel id="notes-type-filter-label">Tipo</InputLabel>
            <Select
              labelId="notes-type-filter-label"
              label="Tipo"
              value={type}
              onChange={({ target }) =>
                onTypeChange(target.value as NoteTypeFilter)
              }
            >
              <MenuItem value="all">Todos</MenuItem>
              {NOTE_TYPES.map((noteType) => (
                <MenuItem key={noteType} value={noteType}>
                  {NOTE_TYPE_LABELS[noteType]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={showDeleted}
                onChange={({ target }) => onShowDeletedChange(target.checked)}
              />
            }
            label="Listar Excluídos"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button onClick={onClose}>Fechar</Button>
        <Button variant="contained" onClick={onApply}>
          Aplicar
        </Button>
      </DialogActions>
    </Modal>
  );
}
